import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import shippingAddressApi from '../../api/shippingAddress';
import ShippingAddress from '../../models/SFModels/ShippingAddress';

import { FETCH_SALESFORCE_DATA } from '../DataServices/SFDataService/actions';
import { FRONT_INFORMATIONS_READY } from '../DataServices/SFDataService/actions';

import * as Actions from './actions';

export function* fetchShippingAddress(action) {
  const shippingAddress = yield call(shippingAddressApi.fetchShippingAddress, action.accountId);
  yield put(Actions.shippingAddressDataTerminateLoading(shippingAddress));
}

export function* populateShippingAddress(action) {
  let address = yield select(state => state.shippingAddress);
  if (action.customerAddress !== null) {
    if (address === null) {
      address = new ShippingAddress(
        action.customerAddress.getId(),
        action.customerAddress.getStreet(),
        action.customerAddress.getCity(),
        action.customerAddress.getZipcode(),
        action.customerAddress.getCountry(),
      );
    } else {
      address = address
        .clone()
        .setId(action.customerAddress.getId())
        .setStreet(action.customerAddress.getStreet())
        .setCity(action.customerAddress.getCity())
        .setZipcode(action.customerAddress.getZipcode())
        .setCountry(action.customerAddress.getCountry());
    }
  }

  yield put(Actions.shippingAddressUpdated(address));
}

export function* shippingAddressListener() {
  yield takeEvery(FETCH_SALESFORCE_DATA, fetchShippingAddress);
  yield takeLatest(FRONT_INFORMATIONS_READY, populateShippingAddress);
}



// WEBPACK FOOTER //
// ./src/services/SFShippingAddressService/saga.js